<template>
  <m-single-lesson-wrapper @access="checkAccess" :course-link="courseLink" :lesson-link="lessonLink">
    <template v-slot="{lesson,access, readStatus,courseSlug,lessonSlug}">
      <div class="col single-lesson-1">
        <div class="card mx-auto">
          <div class="row d-flex flex-row justify-lesson-between p-5">

            <div class="col">
              <h4>{{ lesson.title }}</h4>
            </div>

            <div class="col text-left">

              <div class="d-inline mx-1" v-if="readStatus">
                <button class="btn btn-success rounded-pill">
                  خوانده شده
                  <i class="bi bi-check-circle-fill"></i>
                </button>

              </div>

              <router-link class="d-inline" v-if="courseSlug" :to="{name: 'SingleCourse', params:{slug: courseSlug}}">
                <button class="btn btn-primary rounded-pill" id="to-course"
                        v-t="`lesson.single.back_to_course`"></button>
              </router-link>

            </div>

          </div>
          <hr class="mx-auto">
          <div class="card-body p-4">
            <img id="lesson-img" :src="lesson.thumbnail" :alt="lesson.title"/>

            <div class="about-course">
              <h4 class="mt-5" v-t="`lesson.single.lesson_abstraction_title`"></h4>
              <p v-html="lesson.abstraction"/>
            </div>

            <div class="course-description">
              <h4 class="mt-5" v-t="`lesson.single.lesson_description`"></h4>
              <div class="text-center col-lg-12">
                <router-link v-if="!access && courseSlug" class="text-dark text-decoration-none course-product-link"
                             :to="{name:'SingleCourse',params:{slug:courseSlug}}">
                  <h4 class="text-center rounded-pill p-1 access-to-course"
                      v-html="$t('lesson.single.access_to_course_text')">

                  </h4>
                </router-link>

              </div>
            </div>


            <p class="card-text" v-html="processContent(lesson.body)"/>

            <template v-if="access && getContentForm(lesson)">
              <hr>

              <i @click="printForm()" class="bi bi-printer-fill h5 btn btn-primary rounded-pill px-3"></i>

              <m-form-single1 class="lesson-1-form py-5" :form-id="getContentForm(lesson)"/>

            </template>


            <next-perv-lesson
                v-if="access"
                :courseLink="courseSlug"
                :lessonLink="lessonSlug"
            />


            <div id="read-lesson"></div>
          </div>
        </div>
      </div>
    </template>
  </m-single-lesson-wrapper>
</template>

<script>
import mFormSingle1 from "../../Form/FormSingle/FormSingle1.vue";
import mSingleLessonWrapper from "../../Wrappers/SingleLessonWrapper";
import {mapGetters} from "vuex";
import NextPervLesson from "../NextPervLesson/NextPervLesson.vue";

export default {
  name: "SingleLesson1",
  components: {mSingleLessonWrapper, mFormSingle1, NextPervLesson},
  props: {
    courseLink: {
      default: null
    },
    lessonLink: {
      default: null
    },
  },
  data() {
    return {
      readStatus: false,
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'User/isAuthenticated'
    }),
    lessonLinkComputed() {
      if (this.lessonLink == null) {
        return this.$route.params.slug
      }
      return this.lessonLink
    },
  },
  methods: {
    readLessonEvent() {

      // add setTimeout to make sure items inside wrapper generate, and it is inside the page.
      setTimeout(() => {

        const video = document.getElementById(`read-lesson`);

        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {

              let form = {
                lessonLink: this.lessonLinkComputed
              }

              this.$store.dispatch('Content/setReadLessonWithoutState', form)

            }
          });
        });

        observer.observe(video);
      }, 100)

    },
    checkAccess(access) {
      if (access && this.isAuthenticated) {
        this.readLessonEvent()
      }
    },
    getContentForm(lesson) {
      let item_form = lesson.item_form
      console.log(item_form)
      if (item_form == null) {
        return false
      }
      return item_form.value
    },
    printForm(){
      // lesson-1-form

      // Get the content to print
      const contentToPrint = document.querySelector('.lesson-1-form').innerHTML;

      // Create a new window
      const newWindow = window.open('', '' );


      let styles = '';
      for (const stylesheet of document.styleSheets) {
        try {
          if (stylesheet.cssRules) { // CSS rules available
            for (const rule of stylesheet.cssRules) {
              styles += rule.cssText;
            }
          }
        } catch (e) {
          console.warn("Could not access stylesheet: ", stylesheet.href);
        }
      }

      // Write the content to the new window
      newWindow.document.write(`
        <html dir="rtl">
          <head>
            <title>Print</title>
             <style>
              ${styles}  /* Inject current page styles */
            </style>
            <style>
              @media print {
                body {
                  margin: 20px;
                }
              }
            </style>
          </head>
          <body dir="rtl" class="text-right">
            ${contentToPrint}
          </body>
        </html>
      `);

      // Wait for the content to load and then print
      newWindow.document.close();
      newWindow.focus();
      newWindow.print();
      // newWindow.close();

    }
  }
}
</script>

<style scoped>

.card {
  background-color: #fff;
  max-width: 1000px;
}

.card-body {
  padding: 7px;
}

hr {
  background-color: #707070;
  color: #707070;
  width: 90%;
  display: flex;
  align-self: center;

}

.card-text {
  margin-top: 50px;
  text-align: right;
}

span {
  font-size: 12px;
}

p {
  font-size: 14px;
}

#post-img, #page-img, #lesson-img {
  width: 100%;
  border-radius: 4px;
  object-fit: cover;
  height: 550px;
}

#to-course {
  background-color: var(--primary);
  color: white;
}

.access-to-course {
  background-color: var(--primary);
  color: white;
}

.video-wrapper {
  display: none !important;
}

.course-product-link {
  color: var(--secondary);
  transition: all ease-in-out .2s;
}

.course-product-link :deep(h4 .d-inline-block) {
  transition: all ease-in-out .2s;
}

.course-product-link:hover > :deep(h4 .d-inline-block) {
  color: var(--dark);
  transition: all ease-in-out .2s;
}

.lesson-1-form {
  background: var(--light);
}

</style>